import { AiOutlineCheckCircle, AiOutlineExclamationCircle } from 'react-icons/ai';

interface IProps {
  message: string;
  type?: 'success' | 'error';
}

const SuccessMessage: React.FC<IProps> = ({ message, type = 'error' }) => {
  return (
    <div className="w-full h-full mx-auto text-center flex flex-col justify-center items-center min-h-[65vh]">
      {type === 'success' && (
        <span>
          <AiOutlineCheckCircle size={96} color="green" />
        </span>
      )}
      {type === 'error' && (
        <span>
          <AiOutlineExclamationCircle size={96} color="red" />
        </span>
      )}
      <p className="text-3xl">{message}</p>
    </div>
  );
};

export default SuccessMessage;
